import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceContractFromKios } from 'modules/suppliers/types';

// export type ContractFromKios = typeof schemas.ContractFromKios._type;
export type ContractFromKios = ReplaceContractFromKios;

interface UseSupplyContractProps {
  supplierProfileOperationCode?: string;
  customerOperationCode?: string;
}

const useSupplyContract = (props: UseSupplyContractProps) => {
  const { supplierProfileOperationCode, customerOperationCode } = props;
  const service = useService();

  return useQuery({
    queryKey: ['contracts', supplierProfileOperationCode, customerOperationCode],
    queryFn: async () => {
      try {
        if (!service || !customerOperationCode || !supplierProfileOperationCode) {
          return null;
        }

        const res: ContractFromKios[] =
          await service.SupplierProfileController_listContractBySupplierProfile({
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
            },
            // OpenAPI spec has this as path-only; backend may expect in query too
            queries: {
              supplierProfileOperationCode,
            } as { pageIndex?: number; pageSize?: number; sorts?: string },
          });

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useSupplyContract;
